export default {
  ORDER: "ऑर्डर",
  ORDERS: "ऑर्डर्स",
};
